module.exports = __webpack_public_path__ + "static/media/financial.99b4ba72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/financial.svg
// module id = 276
// module chunks = 0